<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="title">收徒赚奖励</div>
      <div class="sub-title">徒弟每次完成试玩，奖励 <span>20%</span></div>
      <div class="action">
<!--        <div @click="showNext('showWx')"><img src="//cdn.hongbaoxd.com/images/93182eb1326f9036874728094149b097.png" alt=""><div>微信</div></div>  -->
        <div @click="showNext('showQrcode')"><img src="//cdn.hongbaoxd.com/images/180b0ee502d285588558aa727d16010d.png" alt=""><div>二维码</div></div>
        <div @click="showNext('showLink')"><img src="//cdn.hongbaoxd.com/images/32c7d482587a2b0f3e4d5b3e990e1d4e.png" alt=""><div>链接</div></div>
      </div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 210px;
    padding: 30px 42px;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .sub-title {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();

      span {
        color: #EF4F2A;
      }
    }

    .action {
      display: flex;
      justify-content: space-between;

      img {
        width: 44px;
        height: 44px;
      }

      div {
        font-size: 13px;
        color: #B5B5B5;

        @include regular();
      }
    }
  }
</style>
<script>
  import { $toast } from '@/views/common/Loading.js'
  import Dialog from 'components/Dialog'
  import { mapActions } from 'vuex'
  import { getAppID } from '@/utils'
  import { shareWX } from '@/assistant/JSBridge'
  import { URL_LINK_SHARE } from '@/store/modules/user/type'
  // const is_ios_10 = () => {
  //   let re = /OS ((\d{1,2})_\d{1,2}||(\d{1,2})_\d{1,2}_\d{1,2}) like Mac OS X/i

  //   let result = re.exec(window.navigator.userAgent)
  //   let ios_ver = result && result[1] && result[1].substr(0, 2)
  //   return parseInt(ios_ver) === 10
  // }
  export default {
    components: {
      Dialog
    },
    mounted () {
      $bus.$on('shareList', () => {
        this.show()
      })
      if ($storage.get('APP_ID')) {
        $storage.remove('APP_ID')
      }
    },
    destroyed () {
      $bus.$off('shareList')
    },
    methods: {
      ...mapActions({
        shareLink: URL_LINK_SHARE
      }),
      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
      },
      async showNext (name) {
        this.$refs.p.hide()
        if (name === 'showWx') {
          await getAppID()
          await this.shareLink().then((res) => {
            let data = res.data.payload
            let title = data.share_info['title']
            let content = data.share_info['content']
            let img = data.share_info['icon']
            let url = data.share_url_wechat
            let appID = $storage.get('APP_ID')
            shareWX(title, content, img, url, appID, 'wxsession')
              .then((result) => {
                if (result['status'] !== 'ok') {
                  $toast.show('请先安装微信哦！', 1000)
                }
              })
          })
        } else if (name === 'showQrcode') {
          await this.shareLink().then((res) => {
            let data = res.data.payload
            $bus.$emit(name, data.qrcode_url)
          })
        } else {
          await this.shareLink().then((res) => {
            let data = res.data.payload
            $bus.$emit(name, data.share_url)
          })
        }
      }
    }
  }
</script>
